export default __webpack_public_path__ + "static/media/ot_quiz_bg.2b839c01.png";